import { FormDescriptor } from "model/form";
import {
  Pages as PagesModule,
  PATHS_PENDING_ACCOUNT as PATHS_PENDING_ACCOUNT_Module,
} from "routes.mjs";

export const BETA: boolean = false;
export const BETA_SALT: string = "GgqMmuXz78835754mgWbA9K48bEye4FL";
export const BETA_HASH: number = 1748869842; //onelink2022beta

export const BaseURL: string = "https://onelink.to/";
export const BaseURLWww: string = "https://www.onelink.to/";

export const TermsVersion: string = "0.0.1";

export const CookieVersion: number = 1;

export const TEST_PLANS: boolean = false;

export const ACCOUNT_SUMMARY_ID: string = "account";

/////////////////////////////////////////////////////////////////////

const FORMAT_APPSTORE = [
  "itms-apps://itunes.apple.com/",
  "itms-apps://apps.apple.com/",
  "http://itunes.apple.com/",
  "http://geo.itunes.apple.com/",
  "https://itunes.apple.com/",
  "https://geo.itunes.apple.com/",
  "https://apps.apple.com/",
  "https://buy.itunes.apple.com/",
  "https://beta.itunes.apple.com/",
  "https://testflight.apple.com/",
  "https://install.appcenter.ms/",
];

const FORMAT_ANDROID = [
  "https://play.google.com/store/apps/",
  "https://play.google.com/store/apps/",
  "market://details?id=",
  "https://play.app.goo.gl/",
  "https://android.myapp.com/",
  "http://android.myapp.com/",
  "https://appgallery.huawei.com/",
  "http://appgallery.huawei.com/",
  "https://zhushou.360.cn/",
  "http://zhushou.360.cn/",
  "http://app.mi.com/",
  "https://app.mi.com/",
  "http://as.baidu.com/",
  "https://as.baidu.com/",
  "https://install.appcenter.ms/",
];

const FORMAT_WINDOWSMARKET = [
  "http://windowsphone.com/=",
  "https://windowsphone.com/",
  "http://www.windowsphone.com/",
  "http://windowsphone.com/",
  "https://www.microsoft.com/",
  "https://microsoft.com/",
  "http://www.microsoft.com/",
  "http://microsoft.com/",
];

const FORMAT_BLACKBERRY_APPWORLD = [
  "http://appworld.blackberry.com/",
  "https://appworld.blackberry.com/",
  "http://www.amazon.",
  "https://www.amazon.",
];

const FORMAT_AMAZON_APPSTORE = ["http://www.amazon.", "https://www.amazon."];

const FORMAT_FALLBACK = ["http://", "https://"];

/////////////////////////////////////////////////////////////////////

export const OneLinkFieldCustomId = "customId";
export const OneLinkFieldName = "name";
export const OneLinkFieldNameMaxLength = 20;
export const CustomIdMinLength = 4;
export const CustomIdMaxLength = 39; // includes: https://onelink.to/ (19 chars)

export const OneLinkFieldsMain = ["iphone", "ipad", "android", "huawei"];
export const OneLinkFieldsLegacy = ["blackberry", "kindle", "windows"];
export const OneLinkFieldFallback = "fallback";
export const OneLinkSettingParameterForwarding = "parameter_forwarding";

export const OneLinkFieldFormats: { [field: string]: string[] } = {
  iphone: FORMAT_APPSTORE,
  ipad: FORMAT_APPSTORE,
  android: FORMAT_ANDROID,
  huawei: FORMAT_ANDROID,
  blackberry: FORMAT_BLACKBERRY_APPWORLD,
  kindle: FORMAT_AMAZON_APPSTORE,
  windows: FORMAT_WINDOWSMARKET,
  fallback: FORMAT_FALLBACK,
};

/////////////////////////////////////////////////////////////////////

// export const FAQ_ITEMS: FaqItem[] = [
//   {
//     title: "What is a smart download link?",
//     content:
//       "With a smart download link from onelink.to, you don't have to worry about what device your user has.\n\nAs long as you have added all your app download links to your onelink.to smart download link, we will make sure to send the user to the correct app store / marketplace based on the device used.",
//   },
//   {
//     title: "My Google email address has changed, what do I do?",
//     content:
//       'Did you register using Google Sign Up and now your Google email have changed?\n\nAs long as you still can receive emails on the original email address there is a solution.\n\n1. Generate a password to your old email address by clicking the "Forgot Password" button on the Login page.\n\n2. When the new password is set and you are logged in. Go to the User Settings (click your name / email address on the top right) and request to change email to your new Google email address.\n\nAfter the email is updated you can login using Google login and your new email address.',
//   },
//   {
//     title:
//       "I created a onelink smart download link a while ago, but now I can't find it",
//     content:
//       "On our old legacy service it was possible to create links without signing in. Please send us an email on support@onelink.to and we'll do our best to help.",
//   },
//   {
//     title: "Can my colleague and I use the same account?",
//     content:
//       "Yes, upgrade to the Team plan and you can have several users on the same account.",
//   },
// ];

/////////////////////////////////////////////////////////////////////

export interface PageDescriptor {
  path: string;
  title: string;
}

export interface PageCollection {
  [view: string]: PageDescriptor;
}

// export const Pages: PageCollection = {
//   LANDING_PAGE: {
//     path: "/",
//     title: "One link or QR code to apps on App Store and Google Play",
//   },
//   ABOUT: { path: "/about-onelink-to", title: "About" },
//   MY_ONELINKS: { path: "/my-onelinks", title: "My Onelinks" },
//   NEWS: { path: "/news", title: "News" },
//   SUPPORT: { path: "/support", title: "Support & FAQ" },
//   CONTACT: { path: "/contact-us", title: "Contact Us" },
//   REGISTER: { path: "/signup", title: "Sign Up" },
//   SIGNIN: { path: "/login", title: "Login" },
//   COMPLETE_REGISTRATION: {
//     path: "/setup/complete-registration",
//     title: "Complete Registration",
//   },
//   SETUP_PAYMENT: { path: "/payment-setup", title: "Setup Payment" },
//   PAYMENT_SUCCESS: { path: "/payment-success", title: "Payment Successful" },
//   PAYMENT_CANCELLED: { path: "/payment-cancelled", title: "Payment Cancelled" },
//   RESET_PASSWORD: { path: "/user/reset-password", title: "Reset Password" },
//   USER_SETTINGS: { path: "/user/settings", title: "User Settings" },
//   VERIFY_EMAIL: { path: "/user/verify-email", title: "Verify Email" },
//   INVITATION: { path: "/user/invitation", title: "Invitation" },
//   ACCOUNT: { path: "/account", title: "My Account" },
//   PRICING: { path: "/pricing", title: "Pricing" },
//   MANAGE_ACCESS: { path: "/account/manage-access", title: "Manage Access" },
//   TERMS_OF_SERVICE: { path: "/legal/terms", title: "Terms of Service" },
//   PRIVACY_POLICY: { path: "/legal/privacy", title: "Privacy Policy" },
//   LEGAL_NOTICE: { path: "/legal/notice", title: "Legal Notice" },
// };
export const Pages: PageCollection = PagesModule;

export const VALID_PATHS = Object.keys(Pages).map((key) => Pages[key].path);

export const PATHS_PENDING_ACCOUNT = new Set<string>(
  PATHS_PENDING_ACCOUNT_Module
);

// export const PATHS_PENDING_ACCOUNT = new Set<string>([
//   Pages.LANDING_PAGE.path,
//   Pages.NEWS.path,
//   Pages.SUPPORT.path,
//   Pages.COMPLETE_REGISTRATION.path,
//   Pages.VERIFY_EMAIL.path,
//   Pages.RESET_PASSWORD.path,
//   Pages.INVITATION.path,
//   Pages.PRICING.path,
//   Pages.TERMS_OF_SERVICE.path,
//   Pages.PRIVACY_POLICY.path,
//   Pages.LEGAL_NOTICE.path,
// ]);

/////////////////////////////////////////////////////////////////////

export const TopMenu: { [item: string]: PageDescriptor } = {
  home: Pages.LANDING_PAGE,
  about: Pages.ABOUT,
  //news: Paths.NEWS,
  support: Pages.SUPPORT,
  //contact: Paths.CONTACT,
  pricing: Pages.PRICING,
};

/////////////////////////////////////////////////////////////////////

export const AuthProvider: { [provider: string]: string } = {
  EMAIL_PASSWORD: "email-password",
  GOOGLE: "google",
  APPLE: "apple",
};

export const AuthResponse: { [error: string]: string } = {
  USER_ALREADY_EXIST: "user-already-exists",
  USER_LOOKUP_ERROR: "user-lookup-error",
  EMAIL_PASSWORD_MISMATCH: "email-password-mismatch",
  EMAIL_NOT_VERIFIED: "email-not-verified",
  NOT_FOUND: "not-found",
  RATE_LIMIT_BLOCK: "rate-limit-block",
};

export const PASSWORD_RULES =
  "minlength: 8; maxlength: 40; required: lower; required: upper; required: digit;";

/////////////////////////////////////////////////////////////////////
export const PlanFree: string = "free";
export const PlanNonProfit: string = "nonprofit";
export const PlanProfessional: string = "professional";
export const PlanTeam: string = "team";
export const PlanTeamPlus: string = "teamplus";
export const PlanEnterprise: string = "enterprise";

export const Plans = [
  PlanFree,
  PlanNonProfit,
  PlanProfessional,
  PlanTeam,
  PlanTeamPlus,
  PlanEnterprise,
];

export const PlanId = {
  [PlanFree]: 0,
  [PlanNonProfit]: 1,
  [PlanProfessional]: 2,
  [PlanTeam]: 3,
  [PlanTeamPlus]: 4,
  [PlanEnterprise]: 5,
};

export const PlansPaid = [
  PlanNonProfit,
  PlanProfessional,
  PlanTeam,
  PlanTeamPlus,
  PlanEnterprise,
];
export const PlansMonthly = [
  PlanProfessional,
  PlanTeam,
  PlanTeamPlus,
  PlanEnterprise,
];
export const PlansMultiUser = [PlanTeam, PlanTeamPlus, PlanEnterprise];

export const SubscriptionOverdueGracePeriodSeconds: number = 7 * 24 * 3600;
/////////////////////////////////////////////////////////////////////

export const FormRegistrationType: FormDescriptor[] = [
  {
    id: "type",
    type: "radio",
    required: true,
    options: ["company", "nonprofit" /*, "individual"*/],
  },
];

export const FormRegistrationPlan: FormDescriptor[] = [
  {
    id: "plan",
    type: "select",
    required: true,
    options: [
      PlanFree,
      PlanNonProfit,
      PlanProfessional,
      PlanTeam,
      PlanTeamPlus,
      PlanEnterprise,
    ],
    showOptionOnTag: [
      "show_free",
      ["show_non_profit", "!multiple_users"],
      ["!over_limit_professional", "!multiple_users"],
      "!over_limit_team",
      "!over_limit_teamplus",
    ],
    disclaimer: "subscription_disclaimer",
    info: "plans_hidden_over_limit",
    showInfoOnTag: "plans_hidden_over_limit",
  },
  {
    id: "paymentPeriod",
    type: "radio",
    required: true,
    options: ["monthly", "yearly"],
    showOnTag: "monthly_option",
  },
  {
    id: "paidUntil",
    type: "info",
  },
  {
    id: "receiptEmails",
    type: "text",
    required: false,
    showOnTag: "receipt_email",
  },
];

export const FormRegistrationInfo: FormDescriptor[] = [
  { id: "name", type: "text", required: true },
  {
    id: "addressLine1",
    type: "text",
    requiredOnTag: "subscription",
    showOnTag: ["add_address", "subscription"],
    showOnValue: true,
  },
  {
    id: "addressLine2",
    type: "text",
    showOnTag: ["add_address", "subscription"],
    showOnValue: true,
  },
  {
    id: "addressCity",
    type: "text",
    //requiredGroup: "cityOrRegion",
    requiredOnTag: "subscription",
    showOnTag: ["add_address", "subscription"],
    showOnValue: true,
  },
  {
    id: "addressPostalCode",
    type: "text",
    requiredOnTag: "subscription",
    showOnTag: ["add_address", "subscription"],
    showOnValue: true,
  },
  {
    id: "addressRegion",
    type: "text",
    //requiredGroup: "cityOrRegion",
    showOnTag: ["add_address", "subscription"],
    showOnValue: true,
  },
  { id: "country", type: "country", required: true },
  {
    id: "vatNo",
    type: "text",
    showOnTag: ["add_address", "subscription"],
    helpLink:
      "https://en.wikipedia.org/wiki/VAT_identification_number#European_Union_VAT_identification_numbers",
    info: "add_eu_vat_number",
    showInfoOnTag: "eu_company_not_sweden_no_valid_value",
  },
  {
    id: "add_address",
    type: "toggle-tag",
    showOnTag: "!subscription",
  },
];

export const FormRegistrationTerms: FormDescriptor[] = [
  {
    id: "termsAccepted",
    type: "checkbox",
    required: true,
  },
];

export const FormTransferLegacy: FormDescriptor[] = [
  {
    id: "transferLegacy",
    type: "checkbox",
  },
];

/////////////////////////////////////////////////////////////////////

export const PlanFreeOnelinkLimit = 3;

export const StatsRangeFree = 90;

export const PlanPrice = {
  [PlanNonProfit]: { yearly: 30 },
  [PlanProfessional]: { monthly: 10, yearly: 100 },
  [PlanTeam]: { monthly: 25, yearly: 250 },
  [PlanTeamPlus]: { monthly: 40, yearly: 400 },
  [PlanEnterprise]: { monthly: 80, yearly: 800 },
};
export const PlanOnelinkLimit = {
  [PlanFree]: PlanFreeOnelinkLimit,
  [PlanNonProfit]: 3,
  [PlanProfessional]: 10,
  [PlanTeam]: 200,
  [PlanTeamPlus]: 500,
  [PlanEnterprise]: -1,
};
export const PlanUserLimit = {
  [PlanFree]: 1,
  [PlanNonProfit]: 1,
  [PlanProfessional]: 1,
  [PlanTeam]: 10,
  [PlanTeamPlus]: 25,
  [PlanEnterprise]: 100,
};

const planVals = (dict: any) => {
  const list = [];
  for (const plan of Plans) {
    list.push(dict[plan]);
  }
  return list;
};

export const PricePlanContent = [
  {
    id: "eligibility",
    type: "text",
    values: ["all", "private_non_profit", "all", "all", "all", "all"],
  },
  {
    id: "traffic",
    type: "text",
    values: [
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
    ],
  },
  {
    id: "lifetime",
    type: "text",
    values: [
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
    ],
  },
  {
    id: "editing",
    type: "text",
    values: [
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
      "unlimited",
    ],
  },
  {
    id: "adfree",
    type: "boolean_text_mix",
    values: ["adfree_free", true, true, true, true, true],
  },
  { id: "urlCount", type: "numeric", values: planVals(PlanOnelinkLimit) },
  {
    id: "customURLs",
    type: "boolean",
    values: [false, true, true, true, true, true],
  },
  { id: "userCount", type: "numeric", values: planVals(PlanUserLimit) },
  {
    id: "parameterForwarding",
    type: "boolean",
    values: [false, false, false, true, true, true],
  },
  {
    id: "stats",
    type: "heading",
    values: [null, null, null, null, null, null],
  },
  {
    id: "statsDevice",
    type: "boolean",
    values: [true, true, true, true, true, true],
  },
  {
    id: "statsRedirect",
    type: "boolean",
    values: [false, false, true, true, true, true],
  },
  {
    id: "statsCountry",
    type: "boolean",
    values: [false, false, true, true, true, true],
  },
  {
    id: "statsReferringDomain",
    type: "boolean",
    values: [false, false, true, true, true, true],
  },
  {
    id: "statsUTM",
    type: "boolean",
    values: [false, false, false, true, true, true],
  },
  {
    id: "statsRetention",
    type: "heading",
    values: [null, null, null, null, null, null],
  },
  // {
  //   id: "statsRetentionHourly",
  //   type: "numeric",
  //   values: [0, 0, 30, 90],
  //   postfix: " d",
  // },
  {
    id: "statsRetentionDaily",
    type: "text",
    values: [
      "days_" + StatsRangeFree,
      "two_years",
      "two_years",
      "two_years",
      "two_years",
      "two_years",
    ],
  },
];

/////////////////////////////////////////////////////////////////////

export const StatsType: string[] = [
  "device",
  "redirect",
  "referrer",
  "country",
  "utm",
];

export const STATS_MIN_DAYS_TO_LOAD: number = 30;

export const StatColors = [
  "150,108,244",
  "23,69,99",
  "200,110,109",
  "135,135,135",
  "11,48,199",
  "243,137,15",
  "116,220,223",
  "185, 132, 40",
  "230, 94, 160",
  "154, 49, 19",
  "118, 148, 176",
  "241, 175, 153",
  "198, 213, 126",
  "158, 224, 158",
  "194, 59, 35",
  "234, 218, 82",
];

export const StatsRgbValues: { [attr: string]: string } = {
  total: "0,0,0",
  iphone: StatColors[0],
  ipad: StatColors[1],
  android: StatColors[2],
  huawei: StatColors[3],
  windows: StatColors[4],
  blackberry: StatColors[5],
  kindle: StatColors[6],
  other: StatColors[7],
  none: StatColors[8],
  fallback: StatColors[9],
  ios: StatColors[10],
};

/////////////////////////////////////////////////////////////////////
export const LS_COOKIE_SETTINGS = "cookie.settings";
export const LS_GA_CLIENT_ID = "ga.client.id";
export const LS_ATTRIBUTION = "attribution";
export const LS_STATS_CACHE = "stats.cache.";

export const LS_ACCESS_TOKEN = "accesstoken";
export const LS_ONELINK = "onelink";
export const LS_ONELINK_SORTING = "onelink.sorting";
export const LS_REGISTRATION_TYPE = "registration.type";
export const LS_REGISTRATION_INFO = "registration.info";
export const LS_REGISTRATION_PLAN = "registration.plan";
export const LS_STATS_SHOW_CHART = "stats.show.chart.";
export const LS_STATS_SHOWING_TYPE = "stats.showing.type";
export const LS_STATS_START_DATE = "stats.control.startdate";
export const LS_STATS_END_DATE = "stats.control.enddate";
export const LS_STATS_CONTROL_PREDEFINED = "stats.control.predefined";
export const LS_EDITOR_SHOW_ALL_FIELDS = "editor.show.allfields";
export const LS_EDITOR_UTM_PARAMS = "editor.utm.params";


export const LS_EXPERIENCE = [
  LS_ACCESS_TOKEN,
  LS_ONELINK,
  LS_ONELINK_SORTING,
  LS_REGISTRATION_TYPE,
  LS_REGISTRATION_INFO,
  LS_REGISTRATION_PLAN,
  ...StatsType.map((type) => LS_STATS_SHOW_CHART + type),
  LS_STATS_SHOWING_TYPE,
  LS_STATS_START_DATE,
  LS_STATS_END_DATE,
  LS_STATS_CONTROL_PREDEFINED,
  LS_EDITOR_SHOW_ALL_FIELDS,
  LS_EDITOR_UTM_PARAMS,
];

/////////////////////////////////////////////////////////////////////
